import type { ComponentType } from 'react'
import { Navigate, createBrowserRouter } from 'react-router-dom'

import { AppShell } from '@/components/app-shell'

const lazyRoute = (importer: () => Promise<{ default: ComponentType }>) => async () => {
  const route = await importer()

  return {
    Component: route.default,
  }
}

export const router = createBrowserRouter([
  {
    path: '/',
    element: <AppShell />,
    children: [
      {
        index: true,
        element: <Navigate to="/a1" replace />,
      },
      {
        path: 'a1',
        lazy: lazyRoute(() => import('@/routes/a1')),
      },
      {
        path: 'a2',
        lazy: lazyRoute(() => import('@/routes/a2')),
      },
      {
        path: 'a3',
        lazy: lazyRoute(() => import('@/routes/a3')),
      },
      {
        path: 'b',
        lazy: lazyRoute(() => import('@/routes/b')),
      },
      {
        path: 'c',
        lazy: lazyRoute(() => import('@/routes/c')),
      },
      {
        path: 'd',
        lazy: lazyRoute(() => import('@/routes/d')),
      },
      {
        path: 'e',
        lazy: lazyRoute(() => import('@/routes/e')),
      },
      {
        path: '*',
        element: <Navigate to="/a1" replace />,
      },
    ],
  },
])
